/*
 * The chart area of the charts design doc: 259px on the small card and 251px on the medium one,
 * which makes a card with a one-line header 335px tall at both sizes.
 */
export const MAIN_CHART_AREA_CLASS_NAME = 'h-[259px] @min-[500px]:h-[251px]'
